import type {
  ApplicationValidationError,
  DependencyValidationError,
  ReconciliationSpecCreateOperation,
} from '@festina/configuration-general-types/configuration'

import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import { getReconciliationSpecOperationFromDate } from '../../uiModels/reconciliationSpecOperations/helpers'
import type { OperationWithSourceInfo } from '../../uiModels/types'
import { ConfigurationItemOperationsWithErrors } from './ConfigurationItemOperationsWithErrors'
import type { OperationsListVariant } from './types'

type Props = {
  operations: OperationWithSourceInfo<ReconciliationSpecCreateOperation>[]
  errors: ValidationErrorWithLocation<
    ApplicationValidationError | DependencyValidationError
  >[]
  variant: OperationsListVariant
}

export const ReconciliationSpecOperationsWithErrors = ({
  errors,
  operations,
  variant,
}: Props) => (
  <ConfigurationItemOperationsWithErrors
    operations={operations}
    errors={errors}
    variant={variant}
    itemIdFromOperation={(operation) =>
      operation.reconciliationSpec?.specId ?? ''
    }
    link={{
      type: 'reconciliationSpec',
      fromDate: getReconciliationSpecOperationFromDate,
    }}
  />
)
